<template>
  <div class="ui-frame" :class="{ 'ui-frame--app' : $inApp }">
    <transition @enter="enterTransition" @leave="leaveTransition">
      <UIintro
        class="ui-section"
        data-phase="intro"
        v-if="!$store.state.isGamePlaying && !$store.state.introDone && !$store.state.isGameLoading"
      />

      <UILoading
        class="ui-section"
        data-phase="loading"
        v-if="$store.state.isGameLoading"
      />

      <UIgame
        class="ui-section ui-section--game"
        data-phase="game"
        v-if="!$store.state.isGameLoading && $store.state.isGamePlaying"
      />

      <UIendGame
        class="ui-section"
        data-phase="gameover"
        v-if="$store.state.isGameOver"
      />

      <UIpause
        class="ui-section"
        data-phase="pause"
        v-if="
          !$store.state.isGamePlaying
          && !$store.state.isGameOver
          && $store.state.introDone
          && $store.state.showPause
        "
      />
    </transition>

    <CircularButton />

    <transition name="fade">
      <UItutorial
        v-if="$store.state.tutorial >= 0 && $store.state.tutorial < 3"
        class="ui-section ui-section--tutorial"
      />
    </transition>

    <transition @enter="enterLogo" @leave="leaveLogo" appear>
      <div
        class="ui-frame__logo"
        v-if="
          (isMobile && !$store.state.isGamePlaying && !$store.state.introDone && !$store.state.isGameLoading)
          || (!isMobile && ($store.state.isGamePlaying || !$store.state.introDone))
        "
      >
        <AppLogo />
      </div>
    </transition>
  </div>
</template>

<script>
import UIintro from '@/components/UIintro.vue';
import UILoading from '@/components/UILoading.vue';
import UIgame from '@/components/UIgame.vue';
import UIpause from '@/components/UIpause.vue';
import UIendGame from '@/components/UIendGame.vue';
import CircularButton from '@/components/CircularButton.vue';
import UItutorial from '@/components/UItutorial.vue';
import AppLogo from '@/components/AppLogo.vue';
import transition from '@/scripts/transitions';
import { initials, enter, leave } from '@/scripts/animations';

export default {
  name: 'UIFrame',

  components: {
    UIintro,
    UILoading,
    UIgame,
    UIpause,
    UIendGame,
    CircularButton,
    UItutorial,
    AppLogo,
  },

  data() {
    return {
      isMobile: null,
      isFirstEnter: true,
    };
  },

  mounted() {
    this.$eventHub.$on('window-resize', this.resize);
    this.resize();
  },

  methods: {
    enterTransition(el, done) {
      const transitionId = el.dataset.phase;
      transition.get(`${transitionId}-enter`)(el).then(done);
    },
    leaveTransition(el, done) {
      const transitionId = el.dataset.phase;
      transition.get(`${transitionId}-leave`)(el).then(done);
    },
    enterLogo(el, done) {
      initials.get('logo')(el);
      enter.get('logo')(el, this.isFirstEnter ? 1.3 : 0).then(done);
      this.isFirstEnter = false;
    },
    leaveLogo(el, done) {
      leave.get('fade')(el).then(done);
    },
    resize() {
      this.isMobile = window.innerWidth < 768;
    },
  },

  beforeDestroy() {
    this.$eventHub.$off('window-resize', this.resize);
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.ui-frame {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  pointer-events: none;

  .ui-section {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
  }

  > *:not(.ui-section--game):not(.ui-section--tutorial) {
    pointer-events: all;
  }

  &__logo {
    margin-top: 25px;
    width: 100%;

    text-align: center;
  }

  &.ui-frame--app {
    .ui-frame__logo {
      margin-top: 8vh;
    }
  }

  @include mq(ipadP) {
    &__logo {
      margin-top: 8vh;
    }
  }

  @include mq(ipadP, $and: $is-portrait) {
    &__logo {
      margin-top: 9vh;
    }
  }
}
</style>
